module.exports = __webpack_public_path__ + "img/today.8c17fe59.svg";